<template>
    <v-container fluid>
        <v-row align="center">
            <v-col class="d-flex" cols="12" sm="6">
                <v-select
                        :items="items"
                        label="Exercise"
                        v-model="selected"
                ></v-select>
            </v-col>
        </v-row>
        <div class="loading" v-if="loading">
            <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
            ></v-progress-circular>
        </div>
        <div v-else>
            <template v-for="(item, index) in logs">
                <v-card dark :key="index" class="my-2 mx-auto">
                    <v-card-title class="subtitle-1">{{ formatDate(item.date) }}</v-card-title>
                    <v-divider class="mx-1"></v-divider>
                    <div class="pa-1">
                        <v-simple-table>
                            <thead>
                            <tr>
                                <th class="text-left" style="width:10%">Set No.</th>
                                <th class="text-left" style="width:30%">Weight</th>
                                <th class="text-left" style="width:30%">Lifts</th>
                                <th class="text-left" style="width:30%">INOL</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="detail in item.detail" :key="detail.set">
                                <td class="text-left" style="width:30%">{{ detail.set }}</td>
                                <td class="text-left" style="width:30%">{{ detail.weight }}</td>
                                <td class="text-left" style="width:30%">{{ detail.lifts }}</td>
                                <td class="text-left" style="width:40%">{{ detail.inol }}</td>
                            </tr>
                            </tbody>
                            <thead>
                            <tr>
                                <th colspan="2" class="text-right" style="width:50%">Total INOL</th>
                                <th colspan="2" class="text-center" style="width:50%">Intensity</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td colspan="2" class="text-right" style="width:50%">{{ item.inol }}</td>
                                <td colspan="2" class="text-center" style="width:50%">{{ getLevel(item.inol) }}</td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card>
            </template>
        </div>
    </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import moment from 'moment';

export default {
    name: 'ExerciseLog',
    data: () => ({
        selected: null,
        loading: false,
        user: null,
        items: [],
        logs: []
    }),
    beforeCreate() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.user = user;
                this.getExerciseList();
            } else {
                this.user = null;
                this.$router.push({path: 'calculator'});
            }
        });
    },
    watch: {
        selected: function(item, old){
            if(item !== old){
                this.getLog(item);
            }
        }
    },
    methods: {
        getLevel(inol){
            if (inol <= 0.4) {
                return 'Super Easy';
            } else if (inol <= 1) {
                return 'Optimal';
            } else if (inol <= 2) {
                return 'Tough';
            } else if (inol > 2) {
                return 'Crazy';
            }
        },
        formatDate(date) {
            return moment(date, 'YYYYMMDD').format('YY[.]MM[.]DD dddd');
        },
        getLog(exercise){
            this.loading = true;
            firebase.firestore()
                .collection('exerciseLogs')
                .doc(this.user.uid)
                .collection('exercise')
                .doc(exercise)
                .collection('day')
                .get()
                .then(result => {
                    this.logs.length = 0;
                    result.forEach(doc => {
                        this.logs.push(doc.data());
                    });
                    this.logs.sort( (a, b) => parseInt(b.date)-parseInt(a.date));
                    this.loading = false;
                });
        },
        getExerciseList() {
            firebase
                .firestore()
                .collection('user')
                .doc(this.user.uid)
                .collection('exercise')
                .get()
                .then(result => {
                    this.items.length = 0;
                    result.forEach(doc => {
                        this.items.push(doc.id);
                    });
                });
        },
    },
};
</script>
